import { render, staticRenderFns } from "./QuoteBuilderLabourItem.vue?vue&type=template&id=5b679b29"
import script from "./QuoteBuilderLabourItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderLabourItem.vue?vue&type=style&index=0&id=5b679b29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports